const translation = {
  input: 'WEJŚCIE',
  result: 'WYNIK',
  detail: 'SZCZEGÓŁY',
  tracing: 'ŚLEDZENIE',
  resultPanel: {
    status: 'STATUS',
    time: 'CZAS WYKONANIA',
    tokens: 'CAŁKOWITA LICZBA TOKENÓW',
  },
  meta: {
    title: 'METADANE',
    status: 'Status',
    version: 'Wersja',
    executor: 'Wykonawca',
    startTime: 'Czas rozpoczęcia',
    time: 'Czas trwania',
    tokens: 'Liczba tokenów',
    steps: 'Kroki wykonania',
  },
  resultEmpty: {
    title: 'To wykonanie generuje tylko format JSON,',
    tipLeft: 'proszę przejdź do ',
    link: 'panelu szczegółów',
    tipRight: ' aby je zobaczyć.',
  },
  circularInvocationTip: 'W bieżącym przepływie pracy istnieje cykliczne wywoływanie narzędzi/węzłów.',
  actionLogs: 'Dzienniki akcji',
}

export default translation
